"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const setColor = (props) => {
    const colors = props.theme.palettes.button[props.buttonType];
    return (0, styled_components_1.css) `
    color: ${colors.foreground};
    border-color: ${colors.border};
    background-color: ${colors.background};
    &:hover:focus {
      background-color: ${colors.backgroundHover};
      border-color: ${colors.borderHover};
    }
    &:hover {
      background-color: ${colors.backgroundHover};
      border-color: ${colors.borderHover};
    }
    &:focus {
      background-color: ${colors.backgroundFocus};
      border-color: ${colors.borderFocus};
    }
  `;
};
const setBorders = (props) => {
    let borders = props.theme.borders.actionButton;
    switch (props.buttonType) {
        case 'buyNow':
            borders = props.theme.borders.transactionalButton;
            break;
        case 'primary':
            borders = props.theme.borders.actionButton;
            break;
        default:
    }
    return (0, styled_components_1.css)(borders);
};
const setFont = (props) => {
    const font = props.theme.typography.button;
    return (0, styled_components_1.css)(font);
};
exports.ThemedButton = styled_components_1.default.button `
  box-shadow: 0 2px 5px 0 rgb(213 217 217 / 50%);
  padding: 1px 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${setBorders};
  ${setColor};
  ${setFont}
`;
